module.exports = __webpack_public_path__ + "static/media/chevron-up-solid-grey.5a2cbe61.png";